//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CustomFieldDisplayItem } from './CustomFieldDisplayItem';
import { WebsiteBlockType } from './Enums';

export abstract class WebsiteCustomFieldDisplayItem extends ItemBase {
    ID: string | null = null;
    WebsiteID: string | null = null;
    WebsiteBlockID: string | null = null;
    Name: string | null = null;
    OrderIndex: number = 0;
    Field: CustomFieldDisplayItem | null = null;
    abstract readonly WebsiteBlockType: WebsiteBlockType;

    static readonly ClassName: string = "WebsiteCustomFieldDisplayItem";
}
